// import React, { useEffect, useState } from "react";
// import { GoogleMap, Marker, InfoWindow, LoadScript } from '@react-google-maps/api';
// import axiosConfig from "../../Service/axiosConfig";
// import "./address.css"

// const librariesArray = ["places"];

// const AddressModal = ({ setFormData, formData, readOnly, onSave }) => {
//     const [selectedLocation, setSelectedLocation] = useState(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [apiKey, setApiKey] = useState("");
//     const [loading, setLoading] = useState(false);

//     const handlePlaceSearch = () => {
//         const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
//         const request = {
//             query: `${searchQuery} India`,
//             fields: ['name', 'geometry', 'formatted_address'],
//         };
//         placesService.textSearch(request, (results, status) => {
//             if (status === window.google.maps.places.PlacesServiceStatus.OK && results?.length > 0) {
//                 setSearchResults(results);
//             } else {
//                 setSearchResults([]);
//             }
//         });
//     };

//     const getApiKey = async () => {
//         setLoading(true);
//         try {
//             const response = await axiosConfig.get("/masters/googlemapkey/");
//             setApiKey(response.data.results[0].key);
//         } catch (err) {
//             console.log("Error fetching API key:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleResultClick = (result) => {
//         const loc = result.geometry.location.toJSON();
//         setSelectedLocation(loc);
//         setFormData({
//             ...formData,
//             latitude: loc.lat,
//             longitude: loc.lng,
//             address: result.formatted_address,
//         });
//         setSearchQuery(result.name);
//         setSearchResults([]);
//     };

//     const handleMapClick = (e) => {
//         const loc = e.latLng.toJSON();
//         setSelectedLocation(loc);
//         const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${loc.lat},${loc.lng}&key=${apiKey}`;
//         fetch(geocodingApiUrl)
//             .then(res => res.json())
//             .then(data => {
//                 const address = data.results?.[0]?.formatted_address || '';
//                 setFormData({
//                     ...formData,
//                     latitude: loc.lat,
//                     longitude: loc.lng,
//                     address
//                 });
//                 setSearchQuery(address);
//             })
//             .catch(err => console.error("Error fetching address:", err));
//     };

//     useEffect(() => {
//         if (formData.latitude && formData.longitude) {
//             setSelectedLocation({ lat: formData.latitude, lng: formData.longitude });
//         } else {
//             setSelectedLocation({ lat: 17.387140, lng: 78.491684 });
//         }
//         getApiKey();
//     }, [formData]);

//     return (
//         <div>
//             <div className="d-flex">
//                 <input
//                     type="text"
//                     value={searchQuery}
//                     onChange={(e) => {
//                         setSearchQuery(e.target.value);
//                         handlePlaceSearch();
//                     }}
//                     placeholder="Search for a place"
//                     className="form-control"
//                     disabled={readOnly}
//                 />
//             </div>

//             {searchResults.length > 0 && (
//                 <ul className="list-container">
//                     {searchResults.map((result, index) => (
//                         <li key={index} onClick={() => handleResultClick(result)}>
//                             {result.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}

//             {apiKey && (
//                 <LoadScript googleMapsApiKey={apiKey} libraries={librariesArray}>
//                     <GoogleMap
//                         mapContainerStyle={{ width: '100%', height: '250px', marginTop: '10px' }}
//                         center={selectedLocation}
//                         zoom={13}
//                         onClick={readOnly ? null : handleMapClick}
//                     >
//                         {selectedLocation && (
//                             <Marker position={selectedLocation}>
//                                 <InfoWindow position={selectedLocation} className="location-name">
//                                     <div>Selected Location</div>
//                                 </InfoWindow>
//                             </Marker>
//                         )}
//                         {/* {selectedLocation && (
//                             <ul className="list-container">
//                                 {searchResults.map((result, index) => (
//                                     <li key={index} onClick={() => handleResultClick(result)}>
//                                         {result.name}
//                                     </li>
//                                 ))}
//                             </ul>

//                         )} */}
//                     </GoogleMap>
//                 </LoadScript>
//             )}

//             {/* Show current details */}
//             <div style={{ marginTop: '15px' }}>
//                 <div className="row">
//                     <div className="col-md-6"><label className="form-label">Longitude:</label> <div className="input-box"><input value={formData.latitude || ''} className="form-control" /></div></div>
//                     <div className="col-md-6"><label className="form-label">Latitude:</label> <div className="input-box"><input value={formData.longitude || ''} className="form-control" /></div></div>
//                 </div>
//                 <div><label className="form-label">Address:</label> <div className="input-box"><textarea value={formData.address || ''} className="form-control" /></div></div>
//             </div>

//             {/* Save Button */}
//             {/* {!readOnly && (
//         <button
//           className="btn btn-primary"
//           style={{ marginTop: '10px' }}
//           onClick={() => onSave({ 
//             latitude: formData.latitude, 
//             longitude: formData.longitude, 
//             address: formData.address 
//           })}
//         >
//           Save
//         </button>
//       )} */}
//         </div>
//     );
// };

// export { AddressModal };
// import React, { useEffect, useState, useRef } from "react";
// import { GoogleMap, Marker, InfoWindow, LoadScript } from '@react-google-maps/api';
// import axiosConfig from "../../Service/axiosConfig";
// import "./address.css";

// const librariesArray = ["places"];

// const AddressModal = ({ setFormData, formData, readOnly, onSave }) => {
//     const [selectedLocation, setSelectedLocation] = useState(null);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [apiKey, setApiKey] = useState("");
//     const [loading, setLoading] = useState(false);

//     const mapRef = useRef(null); // 👈 map instance reference

//     const handlePlaceSearch = () => {
//         const placesService = new window.google.maps.places.PlacesService(document.createElement('div'));
//         const request = {
//             query: `${searchQuery} India`,
//             fields: ['name', 'geometry', 'formatted_address'],
//         };
//         placesService.textSearch(request, (results, status) => {
//             if (status === window.google.maps.places.PlacesServiceStatus.OK && results?.length > 0) {
//                 setSearchResults(results);
//             } else {
//                 setSearchResults([]);
//             }
//         });
//     };

//     const getApiKey = async () => {
//         setLoading(true);
//         try {
//             const response = await axiosConfig.get("/masters/googlemapkey/");
//             setApiKey(response.data.results[0].key);
//         } catch (err) {
//             console.log("Error fetching API key:", err);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleResultClick = (result) => {
//         const loc = result.geometry.location.toJSON();
//         setSelectedLocation(loc);
//         setFormData({
//             ...formData,
//             latitude: loc.lat,
//             longitude: loc.lng,
//             address: result.formatted_address,
//         });
//         setSearchQuery(result.name);
//         setSearchResults([]);

//         // explicitly pan and zoom map
//         if (mapRef.current) {
//             mapRef.current.panTo(loc);
//             mapRef.current.setZoom(15);
//         }
//     };

//     const handleMapClick = (e) => {
//         const loc = e.latLng.toJSON();
//         setSelectedLocation(loc);

//         const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${loc.lat},${loc.lng}&key=${apiKey}`;
//         fetch(geocodingApiUrl)
//             .then(res => res.json())
//             .then(data => {
//                 const address = data.results?.[0]?.formatted_address || '';
//                 setFormData({
//                     ...formData,
//                     latitude: loc.lat,
//                     longitude: loc.lng,
//                     address
//                 });
//                 setSearchQuery(address);
//             })
//             .catch(err => console.error("Error fetching address:", err));

//         if (mapRef.current) {
//             mapRef.current.panTo(loc);
//             mapRef.current.setZoom(15);
//         }
//     };

//     const onMapLoad = (map) => {
//         mapRef.current = map;
//     };

//     useEffect(() => {
//         if (formData.latitude && formData.longitude) {
//             setSelectedLocation({ lat: formData.latitude, lng: formData.longitude });
//         } else {
//             setSelectedLocation({ lat: 17.387140, lng: 78.491684 });
//         }
//         getApiKey();
//     }, [formData]);

//     return (
//         <div>
//             {/* Search Box */}
//             <div className="d-flex">
//                 <input
//                     type="text"
//                     value={searchQuery}
//                     onChange={(e) => {
//                         setSearchQuery(e.target.value);
//                         handlePlaceSearch();
//                     }}
//                     placeholder="Search for a place"
//                     className="form-control"
//                     disabled={readOnly}
//                 />
//             </div>

//             {/* Search Results */}
//             {searchResults.length > 0 && (
//                 <ul className="list-container">
//                     {searchResults.map((result, index) => (
//                         <li key={index} onClick={() => handleResultClick(result)}>
//                             {result.name}
//                         </li>
//                     ))}
//                 </ul>
//             )}

//             {/* Map */}
//             {apiKey && (
//                 <LoadScript googleMapsApiKey={apiKey} libraries={librariesArray}>
//                     <GoogleMap
//                         mapContainerStyle={{ width: '100%', height: '250px', marginTop: '10px' }}
//                         center={selectedLocation}
//                         zoom={13}
//                         onClick={readOnly ? null : handleMapClick}
//                         onLoad={onMapLoad}
//                     >
//                         {selectedLocation && (
//                             <Marker position={selectedLocation}>
//                                 <InfoWindow position={selectedLocation}>
//                                     <div>Selected Location</div>
//                                 </InfoWindow>
//                             </Marker>
//                         )}
//                     </GoogleMap>
//                 </LoadScript>
//             )}

//             {/* Show current details */}
//             <div style={{ marginTop: '15px' }}>
//                 <div className="row">
//                     <div className="col-md-6">
//                         <label className="form-label">Latitude:</label>
//                         <div className="input-box">
//                             <input value={formData.latitude || ''} className="form-control" readOnly />
//                         </div>
//                     </div>
//                     <div className="col-md-6">
//                         <label className="form-label">Longitude:</label>
//                         <div className="input-box">
//                             <input value={formData.longitude || ''} className="form-control" readOnly />
//                         </div>
//                     </div>
//                 </div>
//                 <div>
//                     <label className="form-label">Address:</label>
//                     <div className="input-box">
//                         <textarea value={formData.address || ''} className="form-control" readOnly />
//                     </div>
//                 </div>
//             </div>

//             {/* Save Button (if needed) */}
//             {/* {!readOnly && (
//                 <button
//                     className="btn btn-primary"
//                     style={{ marginTop: '10px' }}
//                     onClick={() => onSave({ 
//                         latitude: formData.latitude, 
//                         longitude: formData.longitude, 
//                         address: formData.address 
//                     })}
//                 >
//                     Save
//                 </button>
//             )} */}
//         </div>
//     );
// };

// export { AddressModal };
import React, { useEffect, useState, useRef, useCallback } from "react";
import { GoogleMap, Marker, InfoWindow, LoadScript, Polygon } from "@react-google-maps/api";
import axiosConfig from "../../Service/axiosConfig";
import "./address.css";
const librariesArray = ["places"];

const AddressModal = ({ setFormData, formData, readOnly }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [apiKey, setApiKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [mode, setMode] = useState("store");
  const mapRef = useRef(null);
  const placesServiceRef = useRef(null);
  const debounceTimer = useRef(null);
  const [polygonPath, setPolygonPath] = useState([]);

  // Get Google Maps API key (only once)
  useEffect(() => {
    if (!apiKey) {
      setLoading(true);
      axiosConfig
        .get("/masters/googlemapkey/")
        .then((response) => setApiKey(response.data.results[0].key))
        .catch((err) => console.error("Error fetching API key:", err))
        .finally(() => setLoading(false));
    }
  }, [apiKey]);

  const initializeMap = useCallback(() => {
    if (formData?.latitude && formData?.longitude) {
      setSelectedLocation({ lat: Number(formData.latitude), lng: Number(formData.longitude) });
    } else {
      setSelectedLocation({ lat: 17.38714, lng: 78.491684 });
    }
  }, [formData?.latitude, formData?.longitude]);

  useEffect(() => {
    initializeMap();
  }, [initializeMap]);

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
  }, []);

  const handlePlaceSearch = useCallback(
    (query) => {
      if (!query.trim()) {
        setSearchResults([]);
        return;
      }

      if (!placesServiceRef.current) {
        placesServiceRef.current = new window.google.maps.places.PlacesService(
          document.createElement("div")
        );
      }

      const request = {
        query: `${query} India`,
        fields: ["name", "geometry", "formatted_address"],
      };

      placesServiceRef.current.textSearch(request, (results, status) => {
        if (status === window.google.maps.places.PlacesServiceStatus.OK && results) {
          setSearchResults(results);
        } else {
          setSearchResults([]);
        }
      });
    },
    []
  );

  const handleDebouncedSearch = (value) => {
    clearTimeout(debounceTimer.current);
    debounceTimer.current = setTimeout(() => {
      handlePlaceSearch(value);
    }, 300);
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);
    handleDebouncedSearch(value);
  };

  const handleResultClick = useCallback(
    (result) => {
      const loc = result.geometry.location.toJSON();
      setSelectedLocation(loc);
      setFormData({
        ...formData,
        latitude: loc.lat,
        longitude: loc.lng,
        address: result.formatted_address,
      });
      setSearchQuery(result.name);
      setSearchResults([]);

      if (mapRef.current) {
        mapRef.current.panTo(loc);
        mapRef.current.setZoom(15);
      }
    },
    [formData, setFormData]
  );

  // const handleMapClick = useCallback(
  //   (e) => {
  //     const loc = e.latLng.toJSON();
  //     setSelectedLocation(loc);

  //     const geocodingApiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${loc.lat},${loc.lng}&key=${apiKey}`;
  //     fetch(geocodingApiUrl)
  //       .then((res) => res.json())
  //       .then((data) => {
  //         const address = data.results?.[0]?.formatted_address || "";
  //         setFormData({
  //           ...formData,
  //           latitude: loc.lat,
  //           longitude: loc.lng,
  //           address,
  //         });
  //         setSearchQuery(address);
  //       })
  //       .catch((err) => console.error("Error fetching address:", err));

  //     if (mapRef.current) {
  //       mapRef.current.panTo(loc);
  //       mapRef.current.setZoom(15);
  //     }
  //   },
  //   [apiKey, formData, setFormData]
  // );
  const handleMapClick = useCallback(
    (e) => {
      const loc = e.latLng.toJSON();

      // ✅ STORE MODE
      if (mode === "store") {
        setSelectedLocation(loc);

        setFormData((prev) => ({
          ...prev,
          latitude: loc.lat,
          longitude: loc.lng,
        }));
      }

      // ✅ POLYGON MODE
      if (mode === "polygon") {
        setPolygonPath((prev) => {
          const updated = [...prev, loc];

          const formattedPolygon = updated.map((p) => [p.lat, p.lng]);

          setFormData((prevForm) => ({
            ...prevForm,
            polygon: formattedPolygon,
            polygon_coordinates: formattedPolygon,
          }));

          return updated;
        });
      }

      if (mapRef.current) {
        mapRef.current.panTo(loc);
      }
    },
    [mode, setFormData]
  );

  const handleUndoPolygonPoint = () => {
    setPolygonPath((prev) => {
      const updated = prev.slice(0, -1);
      const formattedPolygon = updated.map((p) => [p.lat, p.lng]);
      setFormData((prevForm) => ({
        ...prevForm,
        polygon: formattedPolygon,
        polygon_coordinates: formattedPolygon,
      }));
      return updated;
    });
  };

  const handleClearPolygon = () => {
    setPolygonPath([]);
    setFormData((prevForm) => ({
      ...prevForm,
      polygon: [],
      polygon_coordinates: [],
    }));
  };

  useEffect(() => {
    return () => clearTimeout(debounceTimer.current);
  }, []);
  useEffect(() => {
    const rawPolygon = formData?.polygon || formData?.polygon_coordinates;
    if (!rawPolygon) return;

    try {
      const parsed =
        typeof rawPolygon === "string"
          ? JSON.parse(rawPolygon)
          : rawPolygon;

      // Handle GeoJSON format
      if (parsed?.coordinates && Array.isArray(parsed.coordinates)) {
        const converted = parsed.coordinates[0].map((item) => {
          if (Array.isArray(item)) {
            return { lat: Number(item[0]), lng: Number(item[1]) };
          }
          return {
            lat: Number(item?.lat !== undefined ? item.lat : item?.[0] || 0),
            lng: Number(item?.lng !== undefined ? item.lng : item?.[1] || 0),
          };
        });
        setPolygonPath(converted);
      }
      // Handle array format (either [[lat, lng], ...] or [{lat, lng}, ...])
      else if (Array.isArray(parsed)) {
        const converted = parsed.map((item) => {
          if (Array.isArray(item)) {
            return { lat: Number(item[0]), lng: Number(item[1]) };
          }
          return {
            lat: Number(item?.lat !== undefined ? item.lat : item?.[0] || 0),
            lng: Number(item?.lng !== undefined ? item.lng : item?.[1] || 0),
          };
        });
        setPolygonPath(converted);
      }
    } catch (err) {
      console.log("Polygon parse error:", err);
    }
  }, [formData?.polygon, formData?.polygon_coordinates]);
  return (
    <div>
      <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
        <button
          type="button"
          onClick={() => setMode("store")}
          className={`btn ${mode === "store" ? "btn-primary" : "btn-outline-primary"}`}
        >
          Select Store Location
        </button>

        <button
          type="button"
          onClick={() => setMode("polygon")}
          className={`btn ${mode === "polygon" ? "btn-warning" : "btn-outline-warning"}`}
        >
          Draw Polygon
        </button>

        <span
          className={`badge ${polygonPath.length >= 3 ? "bg-success" : "bg-secondary"}`}
          style={{ fontSize: "13px", padding: "8px 12px" }}
        >
          Polygon Points: {polygonPath.length} {polygonPath.length >= 3 ? "(Valid Boundary)" : "(Min 3 points required)"}
        </span>
      </div>
      {/* Search Box */}
      <div className="d-flex">
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search for a place"
          className="form-control"
          disabled={readOnly}
        />
      </div>

      {/* Search Results */}
      {searchResults.length > 0 && (
        <ul className="list-container">
          {searchResults.map((result, index) => (
            <li key={index} onClick={() => handleResultClick(result)}>
              {result.name}
            </li>
          ))}
        </ul>
      )}

      {/* Map */}
      {apiKey && (
        <LoadScript googleMapsApiKey={apiKey} libraries={librariesArray}>
          <GoogleMap
            mapContainerStyle={{ width: "100%", height: "250px", marginTop: "10px" }}
            center={
              selectedLocation ||
              (polygonPath.length > 0 ? polygonPath[0] : { lat: 17.38714, lng: 78.491684 })
            }
            zoom={13}
            onClick={readOnly ? null : handleMapClick}
            onLoad={onMapLoad}
          >
            {/* {selectedLocation && (
              <Marker position={selectedLocation}>
                <InfoWindow position={selectedLocation}>
                  <div>Selected Location</div>
                </InfoWindow>
              </Marker>
            )} */}
            {selectedLocation && (
              <Marker position={selectedLocation}>
                <InfoWindow position={selectedLocation}>
                  <div>Store Location</div>
                </InfoWindow>
              </Marker>
            )}

            {/* ✅ POLYGON POINTS */}
            {polygonPath.map((point, index) => (
              <Marker
                key={index}
                position={point}
                label={`${index + 1}`}
              />
            ))}

            {/* ✅ POLYGON SHAPE */}
            {polygonPath.length > 2 && (
              <Polygon
                path={polygonPath}
                options={{
                  fillColor: "#FF0000",
                  fillOpacity: 0.3,
                  strokeColor: "#FF0000",
                  strokeOpacity: 1,
                  strokeWeight: 2,
                }}
              />
            )}
          </GoogleMap>
        </LoadScript>
      )}
      <div className="d-flex align-items-center gap-2 mt-2">
        <button
          type="button"
          onClick={handleUndoPolygonPoint}
          disabled={polygonPath.length === 0}
          className="btn btn-secondary"
        >
          Undo Last Point
        </button>
        <button
          type="button"
          onClick={handleClearPolygon}
          disabled={polygonPath.length === 0}
          className="btn btn-danger"
        >
          Clear Polygon
        </button>
      </div>
      {/* Show current details */}
      <div style={{ marginTop: "15px" }}>
        <div className="row">
          <div className="col-md-6">
            <label className="form-label">Latitude:</label>
            <div className="input-box">
              <input
                value={formData.latitude || ""}
                className="form-control"
                readOnly
              />
            </div>
          </div>
          <div className="col-md-6">
            <label className="form-label">Longitude:</label>
            <div className="input-box">
              <input
                value={formData.longitude || ""}
                className="form-control"
                readOnly
              />
            </div>
          </div>
        </div>
        <div>
          <label className="form-label">Address:</label>
          <div className="input-box">
            <textarea
              value={formData.address || ""}
              className="form-control"
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export { AddressModal };
